"use client";

import { Typography } from "@/components/ui/typography";
import { CustomLink } from "@/components/ui/link";
import { ArrowLeft02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
import Image from "next/image";

export default function NotFound() {
  const router = useRouter();

  return (
    <>
      <div className="flex flex-col items-center justify-center gap-8 min-h-[calc(100dvh-350px)] px-4 relative pb-10 md:pb-20">
        {/* Animation container with specific dimensions */}
        <Image
          src="/images/404/404.png"
          alt="404"
          width={457}
          height={569}
          className="w-full max-w-[457px] md:max-w-[590px] h-[569px] flex items-center justify-center -mb-10"
        />

        <div className="text-center space-y-4">
          <Typography variant="bodyMBold" className="md:text-2xl">
            صفحه مورد‌نظر یافت نشد
          </Typography>
          <Typography
            variant="bodySRegular"
            className="text-black md:text-muted-foreground max-w-md"
          >
            صفحه‌ای که به دنبالش هستید وجود ندارد یا حذف شده است.
          </Typography>
        </div>

        <div className="flex items-center gap-4">
          <CustomLink
            variant={"secondary"}
            className="h-10 md:h-11 px-6"
            href="/"
          >
            رفتن به صفحه اصلی
          </CustomLink>
          <Button
            variant={"outline"}
            className="h-10 md:h-11 px-6"
            onClick={() => router.back()}
          >
            بازگشت
            <HugeiconsIcon icon={ArrowLeft02Icon} strokeWidth={1.5} size={20} />
          </Button>
        </div>
      </div>
    </>
  );
}
